import { app } from '../app.module'
app.controller('TrendWordCtrl', ($scope, $rootScope, $state, Restangular) => {
  // アクセスのフラグをチェックして、フラグがない場合は、ブランドにリダイレクトする
  if ($rootScope.flgArchive === false) {
    $state.go('brand')
  }
  $scope.selected = []
  $scope.trendWords = []
  $scope.trendWordCount = 0

  // 取得条件とページング情報のオブジェクトを初期化する
  $scope.getOptions = {
    startEndDate: {
      startDate: null,
      endDate: null,
    },
    hour: null,
    ranking: null,
    type: null,
    keyword: null,
    order: null,
    limit: null,
    page: null,
  }

  $scope.query = {
    limit: 25,
    options: [10, 25, 50],
    page: 1,
    // 画面遷移時は、最新のトレンドワードを1ページ目に表示するため、日付と時間を降順にする
    order: '-datetime,-hour',
  }

  // date-range-pickerが変更された場合は、日付をセットしデータを再取得する
  $rootScope.$on('changeDateRange', (event, data) => {
    if (data !== undefined) {
      $scope.getOptions.startEndDate = {
        startDate: data.startDate,
        endDate: data.endDate,
      }
      // テーブルクエリ設定
      $scope.query = {
        order: '-datetime,-hour',
        limit: 25,
        options: [10, 25, 50],
        page: 1,
        postsCount: null,
      }

      getTrendWordData()
    }
  })

  // 画面遷移時に、初期化処理を行う
  initProcess()

  $scope.$on('changeFilterData', (event, filterData) => {
    if (filterData.type === 'hour') {
      $scope.getOptions.hour = filterData.value
    }
    if (filterData.type === 'rank') {
      $scope.getOptions.ranking = filterData.value
    }
    if (filterData.type === 'trendword-type') {
      $scope.getOptions.type = filterData.value
    }

    // フィルターを変更する
    changeFilter()
  })

  /**
   * キーワードの変更イベント
   * @param {string} keyword キーワード
   */
  $scope.changeKeywordFilter = (keyword: string) => {
    if ($scope.getOptions.keyword === keyword) {
      return
    }
    $scope.getOptions.keyword = keyword
    // フィルターを変更する
    changeFilter()
  }

  /**
   * onReorder ソートのイベント
   * @param {string} order ソート条件
   */
  $scope.onReorder = function (order) {
    // ページングを初期化
    $scope.query.page = 1

    // ソート条件をセットし、データを再取得する
    $scope.query.order = order
    getTrendWordData()
  }

  /**
   * onPaginate ページングを移動するイベント
   */
  $scope.onPaginate = function (page, limit) {
    // ページング情報をセットし、データを再取得する
    $scope.query.page = page
    $scope.query.limit = limit
    getTrendWordData()
  }

  /**
   * トレンドワードデータを取得し、スコープにセットする
   */
  function initProcess() {
    // 初回ロード時は、取得期間を7日前~現在時点に設定する
    $scope.getOptions.startEndDate.startDate = moment().subtract(7, 'days').unix()
    $scope.getOptions.startEndDate.endDate = moment().unix()

    getTrendWordData()
  }

  function getTrendWordData() {
    $scope.isLoading = true
    // ソート条件やページング情報をセットする
    $scope.getOptions.limit = $scope.query.limit
    $scope.getOptions.order = $scope.query.order
    $scope.getOptions.page = $scope.query.page

    const requestUrl = 'trendword/getTrendWord?get_options=' + JSON.stringify($scope.getOptions)

    // 画面遷移時にイベントデータを取得する
    Restangular.all(requestUrl)
      .getList()
      .then((response) => {
        if (response[0].data !== null) {
          $scope.trendWords = response[0].data.trendWordData
          $scope.trendWordCount = response[0].data.trendWordCount
        }
        $scope.isLoading = false
      })
  }

  /**
   * フィルターの変更
   */
  function changeFilter() {
    $scope.query.page = 1
    getTrendWordData()
  }
})
